import { cloneElement, useContext, useEffect, useState } from 'react';
import LoadingSpinner from '../../../../../common/widgets/LoadingSpinner';
import {
  BenefitsContext,
  IBenefitsContext,
} from '../../../contexts/BenefitsContext';
import { TopLevelCategories } from '../../../enums';
import { categoryService } from '../../../services/category';

const rootCategoryMap: Record<number, keyof IBenefitsContext> = {
  [TopLevelCategories.FlexibleBenefits]: 'flexibleBenefitsCategoryRoot',
  [TopLevelCategories.BenefitClub]: 'benefitClubCategoryRoot',
  [TopLevelCategories.Cashback]: 'cashbackCategoryRoot',
  [TopLevelCategories.DiscountVouchers]: 'discountVouchersCategoryRoot',
};

export default function RootCategoryWrapper(props: any) {
  const { topLevelCategoryId } = props;

  const { benefitRoots, setBenefitRoots } = useContext(BenefitsContext);

  const [isLoading, setIsLoading] = useState(false);

  const rootCategoryKey = rootCategoryMap[topLevelCategoryId];

  const rootCategory = rootCategoryKey
    ? benefitRoots[rootCategoryKey]
    : undefined;

  useEffect(() => {
    if (topLevelCategoryId !== TopLevelCategories.Cashback || rootCategory) {
      return;
    }

    const abortController = new AbortController();

    const loadCashback = async () => {
      setIsLoading(true);

      try {
        const result = await categoryService.getCashbackSubCategories({
          signal: abortController.signal,
        });

        if (!result.hasErrors) {
          setBenefitRoots(current => ({
            ...current,
            cashbackCategoryRoot: result.data,
          }));
        }
      } finally {
        setIsLoading(false);
      }
    };

    void loadCashback();

    return () => {
      abortController.abort();
    };
  }, [topLevelCategoryId, rootCategory, setBenefitRoots]);

  if (isLoading || !rootCategory || rootCategory.id !== topLevelCategoryId) {
    return (
      <div className="dialog-actions vertical">
        <LoadingSpinner size="medium" />
      </div>
    );
  }

  return cloneElement(props.children, {
    rootCategory,
    topLevelCategoryId,
  });
}
